import { render, staticRenderFns } from "./saveIES.vue?vue&type=template&id=ecfe24a8&"
import script from "./saveIES.vue?vue&type=script&lang=js&"
export * from "./saveIES.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports